import ItodoImage from "../../../elements/itodo-img";

function SectionOurInfo2() {
  return (
    <div className="section-full p-t110 p-b80 sx-bg-light sx-our-info-outer ">
      <div className="container">
        <div className="section-content">
          <div className="row sx-our-info-content-wrap">
            <div className="col-lg-4 col-md-4">
              <div className="sx-our-info-content">
                <ul>
                  <li><div className="sx-our-info-content-list left"><span className="sx-sub-title">Mission</span><h3 className="sx-bx-title">Deliver quality-monitored protective services with reliability.</h3></div></li>
                  <li><div className="sx-our-info-content-list left"><span className="sx-sub-title">Vision</span><h3 className="sx-bx-title">Be a trusted regional reference for consulting and surveillance excellence.</h3></div></li>
                  <li><div className="sx-our-info-content-list left"><span className="sx-sub-title">Core Value</span><h3 className="sx-bx-title">Transparency, integrity and long-term client partnership.</h3></div></li>
                  <li><div className="sx-our-info-content-list left"><span className="sx-sub-title">Training</span><h3 className="sx-bx-title">HEAT and MRE programs built around realistic field scenarios.</h3></div></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4"><div className="sx-our-info-media-wrap" style={{ minHeight: '100%' }}><div className="sx-our-info-media" style={{ minHeight: '100%' }}><ItodoImage src="/assets/images/neuron-cons/security-black.png" alt="Security professional in black suit" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }} /></div></div></div>
            <div className="col-lg-4 col-md-4">
              <div className="sx-our-info-content">
                <ul>
                  <li><div className="sx-our-info-content-list right"><span className="sx-sub-title">Contact</span><h3 className="sx-bx-title">info@neuronconsultancy.co.ke<br />+254 725 642 469</h3></div></li>
                  <li><div className="sx-our-info-content-list right"><span className="sx-sub-title">Location</span><h3 className="sx-bx-title">Ack garden, 1st Ngong Avenue, 2 Foor, wing A, Nairobi - Kenya</h3></div></li>
                  <li><div className="sx-our-info-content-list right"><span className="sx-sub-title">Coverage</span><h3 className="sx-bx-title">Corporate, NGO and project field support.</h3></div></li>
                  <li><div className="sx-our-info-content-list right"><span className="sx-sub-title">Website</span><h3 className="sx-bx-title">www.neuronconsultancy.co.ke</h3></div></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionOurInfo2;
